export default "__VITE_ASSET__DBURka9v__"